module.exports = __webpack_public_path__ + "static/media/rental-flow-en.1f5b065b.png";